module.exports = __webpack_public_path__ + "static/media/home02.186e2e64.png";